import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var DenseIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 60 60" }),
    React.createElement("defs", null,
        React.createElement("style", null, ".cls-1{fill:#fff}")),
    React.createElement("circle", { cx: 31, cy: 30, r: 28, fill: "#131314" }),
    React.createElement("path", { className: "cls-1", d: "M40.81 40.53H21.17l4.9-16.96h9.68l5.07 16.96Zm-18.13-1.17h16.56l-4.37-14.63h-7.93l-4.26 14.63Z" }),
    React.createElement("path", { className: "cls-1", d: "M30.99 24.62c-2.22 0-4.02-1.81-4.02-4.02s1.81-4.02 4.02-4.02 4.02 1.81 4.02 4.02-1.81 4.02-4.02 4.02Zm0-6.88a2.86 2.86 0 1 0-.001 5.721 2.86 2.86 0 0 0 .001-5.721ZM30.99 44.67c-4.66 0-9.09-1.81-12.42-5.13-.23-.23-.23-.58 0-.82s.58-.23.82 0c6.41 6.41 16.79 6.41 23.2 0 .23-.23.58-.23.82 0s.23.58 0 .82c-3.32 3.26-7.7 5.13-12.42 5.13Z" }))); };

export default DenseIcon;
